export const STATUS_FETCH_REQUEST = 'STATUS_FETCH_REQUEST';
export const STATUS_FETCH = 'STATUS_FETCH';
export const STATUS_CREATE_REQUEST = 'STATUS_CREATE_REQUEST';
export const STATUS_CREATE = 'STATUS_CREATE';
export const STATUS_DELETE_REQUEST = 'STATUS_DELETE_REQUEST';
export const STATUS_DELETE = 'STATUS_DELETE';
export const STATUS_UPDATE_REQUEST = 'STATUS_UPDATE_REQUEST';
export const STATUS_UPDATE = 'STATUS_UPDATE';
export const STATUS_CLEAR = 'STATUS_CLEAR';
